import {Box} from "@mui/material";
import {c} from "../landingTokens";

const BARS = [c.purple, c.purple, c.purpleDeep, c.purpleDeep, c.purpleDeep, c.purple, c.purple];

/** Animated waveform. The keyframes (`bfPulse`) are declared in Hero's <GlobalStyles>. */
export const VoiceBars = ({height = 78}) => (
  <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", height}}>
    {BARS.map((color, i) => (
      <Box
        key={i}
        sx={{
          width: 5,
          height,
          borderRadius: "3px",
          bgcolor: color,
          animation: `bfPulse 1.1s ease-in-out ${i * 0.11}s infinite`,
        }}
      />
    ))}
  </Box>
);
